export default "__VITE_ASSET__iJF1ZZNj__"